var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 63,
    viewBox: "0 0 70 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_97_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 38.1667C38.6819 38.1667 41.6667 35.1819 41.6667 31.5C41.6667 27.8181 38.6819 24.8333 35 24.8333C31.3181 24.8333 28.3334 27.8181 28.3334 31.5C28.3334 35.1819 31.3181 38.1667 35 38.1667Z",
    fill: "#CD773A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 46.5C53.4095 46.5 68.3333 39.7843 68.3333 31.5C68.3333 23.2157 53.4095 16.5 35 16.5C16.5905 16.5 1.66663 23.2157 1.66663 31.5C1.66663 39.7843 16.5905 46.5 35 46.5Z",
    stroke: "#CD773A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0096 39C31.2144 54.9431 44.4923 64.5096 51.6667 60.3675C58.8411 56.2254 57.1951 39.9431 47.9904 24C38.7857 8.0569 25.5077 -1.50966 18.3334 2.63248C11.159 6.77461 12.8049 23.0569 22.0096 39Z",
    stroke: "#CD773A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0096 24C12.8048 39.9431 11.1589 56.2254 18.3333 60.3675C25.5077 64.5096 38.7856 54.9431 47.9903 39C57.1951 23.0569 58.841 6.77461 51.6666 2.63248C44.4922 -1.50966 31.2143 8.0569 22.0096 24Z",
    stroke: "#CD773A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_76"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 63,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactIcon);
export default __webpack_public_path__ + "static/media/React-Icon.8f4f905f1188f05403cdf922cfe2d872.svg";
export { ForwardRef as ReactComponent };